import axios from 'axios';

export const getCountry = {
  userCountry(setCountry) {
    axios.get('https://geolocation-db.com/json/')
    .then((response) => {
      let data = response.data;
      localStorage.setItem('country', data.country_code.toLowerCase())
      setCountry(data.country_code.toLowerCase());
    })
    .catch((error) => {});
}
}
